module.exports = __webpack_public_path__ + "img/concept_2019firkant.055cda1f.png";